import { useStaticQuery, graphql } from 'gatsby';

const useSocialmedia = () => {
  const { strapi } = useStaticQuery(graphql`
    query Socialmedia {
      strapi {
        socialmedia {
          facebook
          youtube
          linkedin
          instagram
          twitter
          snapchat
          clubhouse
          whatsappNumber
          whatsappNumberWithCountryCodeNL: whatsappNumber(withCountryCode: "nl")
          smsNumber
        }
      }
    }
  `);

  return strapi.socialmedia || {};
};

export default useSocialmedia;
